$(function() {

  /*=============================================
      =                 Search                   =
      =============================================*/

  $('.search').on('click', function(event) {
    $('.header-search').addClass('open');
  });

  $('.search-close').on('click', function(event) {
    $('.header-search').removeClass('open');
  });

  /*=====  End of Prealoder  ======*/


  /*=============================================
      =                  Sticky                     =
      =============================================*/

  $(window).on('scroll', function(event) {    
    var scroll = $(window).scrollTop();
    if (scroll < 110) {
      $(".header-area").removeClass("sticky");
    } else{
      $(".header-area").addClass("sticky");
    }
  });

  /*=====  End of Sticky  ======*/ 
  
  
});

/*=============================================
        =                  mobile view drawer                     =
        =============================================*/
function openNavm() {
  document.getElementById("mySidenav").style.width = "320px";
}

function closeNavm() {
  document.getElementById("mySidenav").style.width = "0";
}
document.addEventListener("DOMContentLoaded", function(event) { 
  var acc = document.getElementsByClassName("accordion");
  var panel = document.getElementsByClassName('panel');
  for (var i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      var setClasses = !this.classList.contains('active');
      setClass(acc, 'active', 'remove');
      setClass(panel, 'show', 'remove');
      if (setClasses) {
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("show");
      }
    }
  }
  function setClass(els, className, fnName) {
    for (var i = 0; i < els.length; i++) {
      els[i].classList[fnName](className);
    }
  }
});

/*=============================================
        =                  main  slider                      =
        =============================================*/

function mainSlider() {
  var BasicSlider = $('.slider-active');

  BasicSlider.on('init', function (e, slick) {
    var $firstAnimatingElements = $('.single-slider:first-child').find('[data-animation]');
    doAnimations($firstAnimatingElements);
  });

  BasicSlider.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
    var $animatingElements = $('.single-slider[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
    doAnimations($animatingElements);
  });

  BasicSlider.slick({
    dots: true,
    infinite: true,
    speed: 400,
    fade: true,
    autoplay: true,
    autoplaySpeed: 7000,
    cssEase: 'linear',
    arrows: false,
    pauseOnHover: false,
    customPaging : function(slider, i) {
      var thumb = jQuery(slider.$slides[i]).data();
      return '<a>'+('0'+(i+1))+'</a>';
    },
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false
        }
      }
    ]
  });        

  function doAnimations(elements) {
    var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    elements.each(function () {
      var $this = $(this);
      var $animationDelay = $this.data('delay');
      var $animationType = 'animated ' + $this.data('animation');
      $this.css({
        'animation-delay': $animationDelay,
        '-webkit-animation-delay': $animationDelay
      });
      $this.addClass($animationType).one(animationEndEvents, function () {
        $this.removeClass($animationType);
      });
    });
  }
}
mainSlider();
/*=====  End of Slick Slider  ======*/   


$multiSlideSectionId = $('.multi-slide').data('section-id');
$('.slider1--'+$multiSlideSectionId).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:false,
  autoplaySpeed:3300,
  dots: true,
  arrows:false,
  navigationText: ['<', '>'],
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$('.slider2--'+$multiSlideSectionId).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:6000,
  dots: true,
  arrows:false,
  navigationText: ['<', '>'],
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});
$('.slider3--'+$multiSlideSectionId).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:6500,
  dots: true,
  arrows:false,
  navigationText: ['<', '>'],
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


$('.multiple_items1').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay:false,
  dots: false,
  arrows:false,
  navigationText: ['<', '>'],
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$('.slider_thumbnails').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows:true,
  navigationText: ['<', '>'],
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

$('#collection-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:5500,
  dots: true,
  arrows:false,
  navigationText: ['<', '>'],
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// ======== size guide popup============

 var modal1 = document.getElementById('popup-modal-size');
  var btn = document.getElementById("open-popup-modal-chart");
  var span = document.getElementsByClassName("modal-close1")[0];
  btn.onclick = function() {
    modal1.style.display = "block";
  }
  span.onclick = function() {
    modal1.style.display = "none";
  }
  window.onclick = function(event) {
    if (event.target == modal1) {
      modal1.style.display = "none";
    }
  }
  
  
  $("#open-popup-modal-chart").click(function(){
      $("body").addClass("size_chart_box");
  });
  $(".modal-close1").click(function(){
    $("body").removeClass("size_chart_box");
  });
// ======== size guide popup============  

